// eslint-disable-next-line max-classes-per-file
import {ICashierDisplayConfiguration} from "@/plugins/cashier/cashdro";

export interface IButton {
	ProductID:number;
	Sku:string;
	Color:string;
	Text:string;

}
export interface IButtonConfig {
	GroupID:number;
	Buttons: IButton[]

}

export interface ICustomGroup {
	ID:number;
	Name:string;
	Color:string;
	DisplayOrder:number;
}

export class CashierButtonConfig {
	ButtonConfigs: IButtonConfig[] = [];
	CustomGroups: ICustomGroup[] = [];

	public constructor(data?: any) {
		if(!data){
			return;
		}
		this.ButtonConfigs = data.ButtonConfigs || [];
		this.CustomGroups = data.CustomGroups || [];
	}

	public getSortedCustomGroups(): ICustomGroup[] {
		return [...this.CustomGroups].sort((a, b) => a.DisplayOrder - b.DisplayOrder);
	}

	public nextCustomGroupID(): number {
		let min = Math.min(0, ...this.CustomGroups.map(g => g.ID));
		return min - 1;
	}

	public removeCustomGroup(id:number) {
		this.CustomGroups = this.CustomGroups.filter(g => g.ID != id);
		this.ButtonConfigs = this.ButtonConfigs.filter(c => c.GroupID != id);
	}

	public getJSON(): any {
		return {
			ButtonConfigs: this.ButtonConfigs,
			CustomGroups: this.CustomGroups
		};
	}

}

export class CashierConfig {
	Displays:ICashierDisplayConfiguration[] = [];

	public constructor(data?: any) {
		if(!data){
			return;
		}
		this.Displays = data.Displays;

	}

	public getJSON(): any {
		return {
			Displays: this.Displays
		};
	}
}